import {useLayoutEffect,useRef} from 'react';
import type {ReactNode} from 'react';
import './reveal-page.css';
/** Shared scroll sheet and footer reveal for every secondary app page. */
export function RevealPage({className,children}:{className:string;children:ReactNode}){
 const root=useRef<HTMLDivElement>(null),sheet=useRef<HTMLElement>(null);
 useLayoutEffect(()=>{
  const el=root.current,content=sheet.current;if(!el||!content)return;
  const update=()=>{const footer=el.querySelector<HTMLElement>(':scope > footer');if(!footer)return;el.style.setProperty('--ha-footer-reveal-bottom',Math.min(0,el.clientHeight-footer.offsetHeight)+'px');el.dataset.footerRevealed=String(content.getBoundingClientRect().bottom<=el.getBoundingClientRect().bottom+1);};
  const resize=new ResizeObserver(update);resize.observe(el);resize.observe(content);
  const observeFooter=()=>{const footer=el.querySelector('footer');if(footer)resize.observe(footer);update();};
  const mutation=new MutationObserver(observeFooter);mutation.observe(el,{childList:true});observeFooter();el.addEventListener('scroll',update,{passive:true});
  return()=>{resize.disconnect();mutation.disconnect();el.removeEventListener('scroll',update);};
 },[]);
 return <div ref={root} className="ha-reveal-page"><main ref={sheet} className={className+' ha-page-sheet'}>{children}</main></div>;
}
